import axiosInstance from "./apiinterseptor";
import { toast } from "react-hot-toast";

export interface OBDCallLog {
  _id: string;
  callId?: string;
  mobile?: string;
  status?: string;
  duration?: number;
  callStartTime?: string;
  callEndTime?: string;
  answerTime?: string;
  recordingUrl?: string;
  dtmfInput?: string;
  hangupCause?: string;
  userId?: number;
  campaignId?: string;
  campaignName?: string;
  cli?: string;
  patchDuration?: number;
  bridgeRingDuration?: number;
  retryCount?: number;
  timestamp?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface GetCallHistoryResponse {
  status: string;
  page: number;
  limit: number;
  totalPages: number;
  totalResults: number;
  results: number;
  data: {
    callLogs: OBDCallLog[];
  };
}

/**
 * Get paginated call history
 * @param params - Query parameters for pagination and filtering
 */
export const getCallHistory = async (params: {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  mobile?: string;
  campaignId?: string;
  startDate?: string;
  endDate?: string;
} = {}): Promise<GetCallHistoryResponse> => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.page !== undefined) queryParams.append('page', params.page.toString());
    if (params.limit !== undefined) queryParams.append('limit', params.limit.toString());
    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);
    if (params.mobile) queryParams.append('mobile', params.mobile);
    if (params.campaignId) queryParams.append('campaignId', params.campaignId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    const response = await axiosInstance.get(`/obd/history?${queryParams.toString()}`);
    return response.data;
  } catch (error: any) {
    console.error('Failed to fetch call history:', error.response?.data?.message || error.message);
    toast.error(error.response?.data?.message || 'Failed to fetch call history. Please try again.');
    throw error;
  }
};

